export default __webpack_public_path__ + "static/media/getVaccinated.df6bfefb.svg";